import { render, staticRenderFns } from "./InviteColleague.vue?vue&type=template&id=023b4a4a&scoped=true"
import script from "./InviteColleague.vue?vue&type=script&lang=js"
export * from "./InviteColleague.vue?vue&type=script&lang=js"
import style0 from "./InviteColleague.vue?vue&type=style&index=0&id=023b4a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b4a4a",
  null
  
)

export default component.exports